export default function Brand({ size = "md", className = "" }) {
  const sizes = {
    sm: "text-2xl",
    md: "text-3xl",
    lg: "text-5xl sm:text-6xl",
  };
  return (
    <span
      className={`font-display font-bold tracking-tight ${sizes[size]} ${className}`}
      data-testid="brand-logo"
    >
      <span className="text-blue-700">DE TOILET</span>
      <span className="text-orange-500">MAN</span>
    </span>
  );
}
